import { useEffect, useState } from 'react';
import { format, parseISO } from 'date-fns';
import { MdOutlineSchedule } from 'react-icons/md';
import { useAppSelector } from '@src/redux';
import { currentCompanySelector } from '@src/redux/company';
import { useSetError } from '@src/redux/modals';
import { Size } from '@Components/designConstants';
import { Dropdown } from '@Components/Dropdown';
import { Page } from '@Components/Page';
import { Platform, PlatformType } from './streaming-ml-diagnostics-constants';
import { useStageTwoDiagnostics } from './use-streaming-ml-diagnostics';
import { StreamingStageTwoDiagnostics } from './StreamingStageTwoDiagnostics';
import './StreamingMLDiagnostics.scss';

const DATE_FORMAT = 'MMM d, yyyy h:mm a';

export const StreamingMLDiagnostics = () => {
  const setError = useSetError();
  const company = useAppSelector(currentCompanySelector);
  const [platform, setPlatform] = useState<PlatformType>(Platform.VIDEO);
  const [showDevOSCat, setShowDevOSCat] = useState(false);
  const [showUnseen, setShowUnseen] = useState(false);

  const stageTwo = useStageTwoDiagnostics(company, platform, showDevOSCat);
  const timestamp = stageTwo.data?.stageTwoFileTimeStamp;
  const kpi = stageTwo.data?.kpi;

  useEffect(() => {
    if (stageTwo.error) {
      setError({ message: stageTwo.error.message, reportError: stageTwo.error });
    }
  }, [stageTwo.error, setError]);

  return (
    <Page
      title='Streaming ML Diagnostics'
      pageType='Streaming ML Diagnostics'
      isLoading={stageTwo.isLoading}
      className='streaming-ml-diagnostics'
      minWidth='800px'
      actions={
        <div className='ml-diagnostics-actions'>
          {timestamp && (
            <div className='last-completion-date' data-testid='last-completion-date'>
              <MdOutlineSchedule aria-hidden />
              {`Last completed ${format(parseISO(timestamp), DATE_FORMAT)}`}
            </div>
          )}
          {kpi && (
            // Read-only: the KPI comes from the DAG args, so this only borrows the dropdown look.
            <div className='current-kpi' data-testid='current-kpi'>
              <Dropdown
                size={Size.MD}
                label='KPI'
                options={[{ value: kpi }]}
                value={kpi}
                onChange={() => {}}
                disabled
              />
            </div>
          )}
        </div>
      }
    >
      <StreamingStageTwoDiagnostics
        company={company}
        platform={platform}
        setPlatform={setPlatform}
        showDevOSCat={showDevOSCat}
        setShowDevOSCat={setShowDevOSCat}
        showUnseen={showUnseen}
        setShowUnseen={setShowUnseen}
      />
    </Page>
  );
};
